/**
 * Light Mode Palette — Modern Enterprise Design System
 *
 * Clean, bright, professional palette with refined contrast.
 * Inspired by Linear, Vercel, and modern SaaS platforms.
 */

import {
  COLOR_PRIMARY,
  COLOR_PRIMARY_LIGHT,
  COLOR_PRIMARY_DARK,
  COLOR_SECONDARY,
  COLOR_SECONDARY_LIGHT,
  COLOR_SECONDARY_DARK,
  COLOR_SUCCESS,
  COLOR_SUCCESS_LIGHT,
  COLOR_SUCCESS_DARK,
  COLOR_WARNING,
  COLOR_WARNING_LIGHT,
  COLOR_WARNING_DARK,
  COLOR_DANGER,
  COLOR_DANGER_LIGHT,
  COLOR_DANGER_DARK,
  COLOR_INFO,
  COLOR_INFO_LIGHT,
  COLOR_INFO_DARK,
  COLOR_NEUTRAL,
  COLOR_NEUTRAL_LIGHT,
  COLOR_NEUTRAL_DARK,
  COLOR_BG_DEFAULT,
  COLOR_BG_PAPER,
  COLOR_BORDER,
} from './tokens.js';

const lightPalette = {
  mode: 'light',
  primary: {
    main: COLOR_PRIMARY,
    light: COLOR_PRIMARY_LIGHT,
    dark: COLOR_PRIMARY_DARK,
    contrastText: '#ffffff',
  },
  secondary: {
    main: COLOR_SECONDARY,
    light: COLOR_SECONDARY_LIGHT,
    dark: COLOR_SECONDARY_DARK,
    contrastText: '#ffffff',
  },
  success: {
    main: COLOR_SUCCESS,
    light: COLOR_SUCCESS_LIGHT,
    dark: COLOR_SUCCESS_DARK,
    contrastText: '#ffffff',
  },
  warning: {
    main: COLOR_WARNING,
    light: COLOR_WARNING_LIGHT,
    dark: COLOR_WARNING_DARK,
    contrastText: '#ffffff',
  },
  error: {
    main: COLOR_DANGER,
    light: COLOR_DANGER_LIGHT,
    dark: COLOR_DANGER_DARK,
    contrastText: '#ffffff',
  },
  info: {
    main: COLOR_INFO,
    light: COLOR_INFO_LIGHT,
    dark: COLOR_INFO_DARK,
    contrastText: '#ffffff',
  },
  grey: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
    main: COLOR_NEUTRAL,
    light: COLOR_NEUTRAL_LIGHT,
    dark: COLOR_NEUTRAL_DARK,
    contrastText: '#ffffff',
  },
  background: {
    default: COLOR_BG_DEFAULT,
    paper: COLOR_BG_PAPER,
  },
  text: {
    primary: '#0f172a',
    secondary: '#475569',
    disabled: '#94a3b8',
  },
  divider: COLOR_BORDER,
  action: {
    active: 'rgba(15, 23, 42, 0.56)',
    hover: 'rgba(15, 23, 42, 0.04)',
    selected: 'rgba(37, 99, 235, 0.08)',
    disabled: 'rgba(15, 23, 42, 0.26)',
    disabledBackground: 'rgba(15, 23, 42, 0.06)',
    focus: 'rgba(37, 99, 235, 0.12)',
  },
};

export default lightPalette;
